import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  DialogActions,
  Button,
  Collapse,
  IconButton,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import CustomRadioGroup from './Components/CustomRadioGroup';
import PreviousMsgGrid from './Components/PreviousMsgGrid';
import CustomTextField  from "../DriverPopUp/common/CustomTextField";
import Select from "../../../../common/StyledSelect";
import clsx from 'clsx';
import { compose } from "recompose";
import MESSAGES from "../../../../../appMessages";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getDataWithQueryString, postData } from "../../../../../api/componentAPIs";
import styles from "./style";
import constant from "./groupMessageConstants";
import { v4 as uuidv4 } from "uuid";
import appConstants from "../../../../../appConstants";
import { withAppConfig } from "../../../../../appConfigContext";
import { getGridFeatureFlagsByGridNames } from "../../../utils";
import { sanitizeInput } from "../../../../../utilities/dataUtils";

class GroupMsgLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prevGroupMessageData: [],
      message: "",
      expanded: false,
      selectedDrivers: "",
      selectedZone: "",
      selectedDriverChoice: constant.RADIO_TYPE.SELECTED_DRIVERS,
      errorInfo: this.getDefaultGroupMsgErrorInfo(),
      isMessageButtonDisabled: false,
      isDataLoaded: false,
    };
    this.errorMessage= ""
    this.isMessageSent = false
    this.enableDriverZone = getGridFeatureFlagsByGridNames(
      this.props.configJSON?.gridConfiguration,
      appConstants.gridNames.DispatchedDriverGrid
    )[appConstants.gridColumnFeatureFlag.DispatchedDriverGrid.EnableDriverZone];
  }

  componentDidMount() {
    this._isComponentMounted = true;
  }

  componentWillUnmount() {
    this._isComponentMounted = false;
  }

  getDefaultGroupMsgErrorInfo() {
    return {
      message: "",
      selectedDriverChoice: "",
      selectedDrivers: "",
      selectedZone: "",
    };
  }

  getMatchedDriverNameByDriverId = (driverId) => {
    return this.props.dispatchDrivers.find(driver => driver.value === driverId)?.label ?? false
  }

  getDriversName = (driverIdList) => {
    if (!driverIdList) return "All";
    const driversNameList = []
    driverIdList.forEach(driverId => {
      let driverName = this.getMatchedDriverNameByDriverId(driverId)
      driverName && driversNameList.push(driverName)
    })
    return driversNameList.join(", ")
  }

  prepareMessageData = (data) => {
    return data.map(rowData => {
      return {
        ...rowData,
        driverIds: this.getDriversName(rowData.driverIds)
      }
    })
  }

  getDispatchGroupMessages = () => {
    this.errorMessage = "loading"
    const terminalCode = this.props.userData.userProfile.terminal.code;
    getDataWithQueryString(
      "GetDispatchGroupMessages",
      `terminalCode=${terminalCode}`
    ).then(response => {
      if (this._isComponentMounted) {
        this.errorMessage = "success"
        if (response && response.status === 200) {
          this.setState({
            prevGroupMessageData: this.prepareMessageData(response.data),
            isDataLoaded: true,
          })
        } else{
          this.setState({ prevGroupMessageData: [] })
        }
      }
    }).catch(err => {
      this.errorMessage= "error"
      if(this._isComponentMounted){
        this.setState({ prevGroupMessageData: [] });
      }
    });
  };

  disableMessageButton = (isMessageButtonDisabled) => {
    this.setState({ isMessageButtonDisabled });
  }

  getDriverIdsForSelectedZone = () => {
    const selectedZoneList = this.state.selectedZone.split(",").map(Number);
    const allDriversInSelectedZone = [];
    selectedZoneList.forEach((eachZone) =>
      allDriversInSelectedZone.push(
        ...this.props.driversZoneDetails.zoneBasedDrivers[eachZone],
      ),
    );
    return allDriversInSelectedZone;
  };

  getDriverIds = () => {
    const { selectedDriverChoice } = this.state;
    if (selectedDriverChoice === constant.RADIO_TYPE.SELECT_ZONE_WISE) {
      return this.getDriverIdsForSelectedZone();
    } else if (selectedDriverChoice === constant.RADIO_TYPE.SELECTED_DRIVERS) {
      return this.state.selectedDrivers.split(",");
  }
    return null;
  };
  
  handleMessageClick = () => {
    const errorInfo = this.getErrorInfo();
    const error = Object.values(errorInfo).filter(value => value).length;
    if (!error) {
      const inputObj = {
        userId: this.props.userData.userProfile.userId,
        terminalCode : this.props.userData.userProfile.terminal.code,
        message: sanitizeInput(this.state.message),
        driverIds: this.getDriverIds(),
        eventDateTime: new Date(),
      }
      const newOutputMessageObj = this.prepareMessageData([{
        dispatcher: this.props.userData.userProfile?.userName,
        driverIds: inputObj.driverIds,
        terminalCode: inputObj.terminalCode,
        messageId: uuidv4(),
        message: inputObj.message,
        createdDateTime: inputObj.eventDateTime,
        }
      ])
      this.disableMessageButton(true);
      postData("SendDispatchGroupMessages", inputObj).then((response) => {
        if (response && Math.trunc(response.status/100) === 2) {
          this.isMessageSent= true
          this.props.enqueueSnackbar(MESSAGES.GROUP_MESSAGE.SUCCESS, {variant: "success"});
          !this.state.isDataLoaded && this.getDispatchGroupMessages()
          this.setState({
            message: "",
            selectedDrivers: "",
            errorInfo: this.getDefaultGroupMsgErrorInfo(),
            prevGroupMessageData: newOutputMessageObj.concat(this.state.prevGroupMessageData),
            isMessageButtonDisabled:false
          })
          this.props.onCancel();
        } else {
          this.handleError(response.status);
        }
      }).catch(() => {
        this.handleError();
      });
    }
  };

  handleError = (statusCode) => {
    this.disableMessageButton(false);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(MESSAGES.GROUP_MESSAGE.FAILURE, {variant: "error"});
  }

  getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(this.state.errorInfo).forEach(fieldName => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state[fieldName]
      );
    });
    this.setState({
      errorInfo
    });
    return errorInfo;
  };

  validateDriverSelectionChoice(value) {
    if (this.isMessageSent) {
      this.isMessageSent = false;
      return null;
    } else if (
      this.state.selectedDriverChoice === constant.RADIO_TYPE.SELECTED_DRIVERS
    ) {
      return value && value.trim()
        ? null
        : constant.VALIDATION_ERROR.DRIVER_REQUIRED;
    }
    return null;
  }

  validateSelectedZoneChoice(value) {
    if (this.isMessageSent) {
      this.isMessageSent = false;
      return null
    } else if (
      this.state.selectedDriverChoice === constant.RADIO_TYPE.SELECT_ZONE_WISE
    ) {
      return value && value.trim()
        ? null
        : constant.VALIDATION_ERROR.ZONE_REQUIRED;
    }
    return null;
  }
  getFieldError = (field, value) => {
    switch (field) {
      case "selectedDrivers":
        return this.validateDriverSelectionChoice(value);
      case "selectedZone":
        return this.validateSelectedZoneChoice(value);
      case "message":
        return value && value.trim()
          ? null
          : constant.VALIDATION_ERROR.REQUIRED;
      default:
        return null;
    }
  }

  handleChange = (field) => (value) => {
    if (["selectedDrivers", "selectedZone"].includes(field)) {
      value = value?.map(option => option.value).join(",") ?? "";
    }
    if (field === "selectedDriverChoice") {
      this.setState(prevState => ({
        selectedDrivers: "",
        selectedZone: "",
        [field]: value,
        errorInfo: {
          ...prevState.errorInfo,
          message: null,
          selectedDrivers: null,
          selectedZone: null
        },
      }))
    } else {
      this.setState(prevState => ({
        [field]: value,
        errorInfo: {
          ...prevState.errorInfo,
          [field]: this.getFieldError(field, value)
        },
      }))
    }
  }

  handleExpandClick = () => {
    !this.state.isDataLoaded && this.getDispatchGroupMessages()
    this.setState(state => ({ expanded: !state.expanded }));
  };

  getRadioOptionBasedOnFeatureFlag = () => {
    if (this.enableDriverZone) {
      return constant.RADIO_LABELS;
    }
    return constant.RADIO_LABELS.filter(
      (radioOption) => radioOption.value !== constant.RADIO_TYPE.SELECT_ZONE_WISE
    );
  };

  render() {
    const { classes } = this.props;
    const { theme } = this.props.userData?.userProfile || {}; 
    return (
      <Dialog
        maxWidth="lg"
        open={this.props.isOpen}
        onClose={this.props.onClose}
        classes={{ paper: classes.dialogContainer }}
        className={`${classes.dialogWrapper} ${theme}`}
      >
        <DialogTitle disableTypography className={classes.dialogTitle}>
          Group Message
          <span className={classes.headerDescription}>
            Send a message to more than one driver at the terminal
          </span>
          <Divider className={classes.divider} />
        </DialogTitle>
        <DialogContent className="customScroll">
          <CustomRadioGroup
            onChange={this.handleChange("selectedDriverChoice")}
            labels={this.getRadioOptionBasedOnFeatureFlag()}
            defaultValue={constant.RADIO_TYPE.SELECTED_DRIVERS}
            customClass={classes.radioContainer}
          />
          <Collapse
            in={
              constant.RADIO_TYPE.SELECTED_DRIVERS ===
              this.state.selectedDriverChoice
            }
            timeout="auto"
            unmountOnExit
          >
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "driverList",
                  label: "Select Driver",
                  variant: "outlined",
                  helperText: this.state.errorInfo?.selectedDrivers,
                }}
                name="selectedDrivers"
                isMulti
                isValueArrayOfObject
                error={Boolean(this.state.errorInfo?.selectedDrivers)}
                value={
                  this.state.selectedDrivers &&
                  this.state.selectedDrivers.split(",")
                }
                onChange={this.handleChange("selectedDrivers")}
                data={this.props.dispatchDrivers}
              />
            </div>
          </Collapse>
          <Collapse
            in={
              constant.RADIO_TYPE.SELECT_ZONE_WISE ===
              this.state.selectedDriverChoice
            }
            timeout="auto"
            unmountOnExit
          >
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "zoneWise",
                  label: "Select Zone",
                  variant: "outlined",
                  helperText: this.state.errorInfo?.selectedZone,
                }}
                name="selectedZone"
                isMulti
                error={Boolean(this.state.errorInfo?.selectedZone)}
                value={
                  this.state.selectedZone &&
                  this.state.selectedZone.split(",").map(Number)
                }
                onChange={this.handleChange("selectedZone")}
                data={this.props.driversZoneDetails.driversZone}
              />
            </div>
          </Collapse>
          <CustomTextField
            id="message"
            className={classes.fullWidth}
            value={this.state.message}
            handleChange={this.handleChange("message")}
            label="Type message here..."
            multiline
            error={this.state.errorInfo.message}
            rows={4}
          />
        </DialogContent>
        <DialogActions classes={{ root: classes.dialogActionStyle }}>
          <div className={classes.showPrevMsg}>
            <span className={classes.showPrevMsgLabel}>
              {this.state.expanded
                ? "Hide Previous Messages"
                : "Show Previous Messages"}
            </span>
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: this.state.expanded,
              })}
              onClick={this.handleExpandClick}
              aria-expanded={this.state.expanded}
              aria-label="Show Previous Messages"
            >
              <ExpandMoreIcon className={classes.expandIcon} />
            </IconButton>
          </div>
          <div className={classes.actionButton}>
            <Button
              variant="outlined"
              onClick={this.props.onCancel}
              color="primary"
              className={classes.dialogButtonStyle}
            >
              Cancel
            </Button>
            <Button
              autoFocus
              variant="contained"
              onClick={this.handleMessageClick}
              color="primary"
              className={classes.dialogButtonStyle}
              disabled={this.state.isMessageButtonDisabled}
            >
              Message
            </Button>
          </div>
        </DialogActions>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <DialogContent>
            <div className={`${classes.headerStyle} ${classes.headerLabel}`}>
              Previous Messages
            </div>
            <PreviousMsgGrid
              prevGroupMessageData={this.state.prevGroupMessageData}
              errorMessage={this.errorMessage}
              isDataLoaded={this.state.isDataLoaded}
              terminalOffset={this.props.userData.userProfile.terminal.offset}
            />
          </DialogContent>
        </Collapse>
      </Dialog>
    );
  }
}

export default compose(
  withStyles(styles),
  withSnackbar,
  withAppConfig
)(GroupMsgLayout);